var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShelf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,4.8h-2.6c-.3,0-.6.3-.6.6v10.7c0,.3.3.6.6.6h2.6c.3,0,.6-.3.6-.6V5.4c0-.3-.3-.6-.6-.6ZM3.2,8.2h1.4v5.1h-1.4v-5.1ZM4.6,6v1h-1.4v-1h1.4ZM3.2,15.5v-1h1.4v1h-1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3,3.3h-2.6c-.3,0-.6.3-.6.6v12.2c0,.3.3.6.6.6h2.6c.3,0,.6-.3.6-.6V3.9c0-.3-.3-.6-.6-.6ZM7.2,7.1h1.4v5.8h-1.4v-5.8ZM8.7,4.5v1.4h-1.4v-1.4h1.4ZM7.2,15.5v-1.4h1.4v1.4h-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,5.5h-2.6c-.3,0-.6.3-.6.6v10c0,.3.3.6.6.6h2.6c.3,0,.6-.3.6-.6V6.1c0-.3-.3-.6-.6-.6ZM11.3,8.9h1.4v4.4h-1.4v-4.4ZM12.7,6.7v1h-1.4v-1h1.4ZM11.3,15.5v-1h1.4v1h-1.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4,3.3h-2.6c-.3,0-.6.3-.6.6v12.2c0,.3.3.6.6.6h2.6c.3,0,.6-.3.6-.6V3.9c0-.3-.3-.6-.6-.6ZM15.4,7.1h1.4v5.8h-1.4v-5.8ZM16.8,4.5v1.4h-1.4v-1.4h1.4ZM15.4,15.5v-1.4h1.4v1.4h-1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelf);
export default __webpack_public_path__ + "static/media/shelf.f42405788421f7d576d72d12e47c77c5.svg";
export { ForwardRef as ReactComponent };